import styled from 'styled-components';
import { useCrossLinks } from 'components/pdp/v3/hooks';
import { mediaMMdMax } from 'helpers/breakpoints';

interface Link {
  url: string;
  title: string;
}

interface CrossLinksData {
  category_links: Link[];
  location_links: Link[];
  nearby_links: Link[];
}

export default function CrossLinks({ boatId }: { boatId: string }) {
  const { crossLinks } = useCrossLinks(boatId) as { crossLinks: CrossLinksData | undefined };

  if (!crossLinks) return null;

  const allLinks = [
    ...(crossLinks.category_links || []),
    ...(crossLinks.location_links || []),
    ...(crossLinks.nearby_links || []),
  ];
  if (!allLinks.length) return null;

  return (
    <Wrapper data-testid="pdp-cross-links">
      <Heading>Explore more boat rentals</Heading>
      <Pills>
        {allLinks.map((link) => (
          <Pill key={link.url} href={link.url}>
            {link.title.split(',')[0]}
          </Pill>
        ))}
      </Pills>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  padding-top: 60px;

  ${mediaMMdMax} {
    padding-top: 35px;
  }
`;

const Heading = styled.h2`
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 20px;

  ${mediaMMdMax} {
    font-size: 16px;
    margin-bottom: 14px;
  }
`;

const Pills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Pill = styled.a`
  display: inline-block;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid #dbdfe5;
  color: #333 !important;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover {
    background-color: #f5f7f9;
    border-color: #333;
  }
`;
